<div class="container">
    <mat-dialog-title class="title-block">
        <h2>APPROVE PRO(S)</h2>
        <app-close-x-icon (click)="onClose()"></app-close-x-icon>
    </mat-dialog-title>

    <div class="partner-container">
        <div class="partner-block">
            <span id="partner-label">PARTNER:</span>

            <span id="partner-name">
                {{partner.name}}
            </span>
        </div>
    </div>

    <mat-dialog-content class="content-block">

        <div class="content-container">

            <div class="content">
                <mat-grid-list cols="2" rowHeight="2:1" class="pro-list" *ngFor="let pro of pros; let i = index">

                    <mat-grid-tile class="pro-details">
                        {{pro.type}} 
                        <app-bullet-icon></app-bullet-icon>
                        {{pro.year}}
                        <app-bullet-icon></app-bullet-icon>
                        {{pro.quarter}}
                    </mat-grid-tile>

                    <mat-grid-tile class="checkbox-field" >
                        <section class="" [ngClass]="{'selected-checkbox' : pro.selected}">
                            <mat-checkbox [(ngModel)]="pro.selected"></mat-checkbox>
                            <mat-label class="checkbox-label">Select</mat-label>
                        </section>
                    </mat-grid-tile>

                </mat-grid-list>
            </div>

        </div>

    </mat-dialog-content>

    <mat-dialog-actions class="action-block">
        <button class="approve-btn" mat-button (click)="approvePros()">APPROVE</button>
        <button class="cancel-btn" mat-button (click)="onClose()">CANCEL</button>
    </mat-dialog-actions>
</div>